import type { OneSchemaImporterContactType } from "@/react/components/SettingsApp/ManageMembers/ImportContacts/hooks/useOneSchemaImporter";

import { absolutePath } from "./absolutePath";

export const oneSchemaConfiguration = {
  retrieve: (contactType: OneSchemaImporterContactType) =>
    absolutePath("import/one_schema/configuration", {
      contact_type: contactType,
    }),
};
